import React, {useState} from 'react';
import Modal from 'react-modal';
import { AiFillCloseCircle } from "react-icons/ai";
import { ReactComponent as BrandLogo} from 'assets/img/love-little-dragons-logo.svg';
import button from 'assets/scss/_button.module.scss';
import style from 'assets/scss/modal.module.css';

const customStyles = {
 content: {
  border: '0'
 },
 overlay: {
  backgroundColor: 'rgba(0,0,0,0.85)',
  zIndex: 1050,
 }
}

const questionSet = [
  {
    _id: 1,
    question: 'Which statement best describes you?',
    choices: [
      {
        _id: 1,
        answer: 'I am ambitious and driven.'
      },
      {
        _id: 2,
        answer: 'I yearn for the ideal.'
      },
      {
        _id: 3,
        answer: 'I am a people person.'
      },
      {
        _id: 4,
        answer: 'I want to discover and try new experiences.'
      },
      {
        _id: 5,
        answer: 'I am passionate about my work.'
      }
    ]
  },
  {
    _id: 2,
    question: 'What is your favorite Bruce Lee film of all time?',
    choices: [
      {
        _id: 1,
        answer: 'Game of Death'
      },
      {
        _id: 2,
        answer: 'The Way of the Dragon'
      },
      {
        _id: 3,
        answer: 'Enter the Dragon'
      },
      {
        _id: 4,
        answer: 'Fist of Fury'
      },
      {
        _id: 5,
        answer: 'The Big Boss'
      }
    ]
  },
  {
    _id: 3,
    question: 'What Bruce Lee quote do you relate to the most?',
    choices: [
      {
        _id: 1,
        answer: `Don't just talk. Do!`
      },
      {
        _id: 2,
        answer: 'Simplicity is the key to brilliance.'
      },
      {
        _id: 3,
        answer: 'Man, he is constantly growing and when he is bound by a set pattern of ideas or way of doing things, that’s when he stops growing.'
      },
      {
        _id: 4,
        answer: 'Always be yourself, express yourself, have faith in yourself. Do not go out and look for a successful personality and duplicate him.'
      },
      {
        _id: 5,
        answer: 'Love is way more than romance.'
      }
    ]
  },
  {
    _id: 4,
    question: 'Who is your favorite Bruce Lee opponent?',
    choices: [
      {
        _id: 1,
        answer: 'Mantis'
      },
      {
        _id: 2,
        answer: 'Colt'
      },
      {
        _id: 3,
        answer: 'Han'
      },
      {
        _id: 4,
        answer: 'Hiroshi Suzuki'
      },
      {
        _id: 5,
        answer: 'Hsiao Mi & Hsaio Chiun'
      }
    ]
  },
  {
    _id: 5,
    question: 'What would you do on your free time?',
    choices: [
      {
        _id: 1,
        answer: 'Go to the gym'
      },
      {
        _id: 2,
        answer: 'Read books'
      },
      {
        _id: 3,
        answer: 'Go to a new restaurant'
      },
      {
        _id: 4,
        answer: 'Go to a museum'
      },
      {
        _id: 5,
        answer: 'Spend time with my family or friends'
      }
    ]
  },
]

Modal.setAppElement('#root');

export default function TribesModal ({show, close, setTribesResultModal, setResult, setPage, page}) {
  const [answers, setAnswers] = useState([0, 0, 0, 0, 0]);
  const [numberOfOccurrence, setNumberOfOccurrence] = useState({});
  const [isArrayValuesEqual, setIsArrayValuesEqual] = useState(false);
  const [isRequired, setIsRequired] = useState(false);

  let result;

  const handleSelect = (answers, index, newValue) => {
    let newState = [...answers];
    newState[index] = newValue;
    setAnswers(newState);
  }

  const handleQuiz = () => {
    setPage(1);
  }

  const handleNextPage = (page) => {
    let savedPage = page;
    if (answers[savedPage-1] === 0) return setIsRequired(true);
    setIsRequired(false);
    setPage(page + 1);
  }

  const handlePrevPage = () => {
    setPage(page - 1);
  }

  const handleReadMore = (result) => {
    close();
    setTribesResultModal(true);
    setResult(result);
  }

  const handleClose = () => {
    setAnswers([0,0,0,0,0])
    setPage(0);
    close();
  }

  const countOccurrence = (arr) => {
    const counts = {};
    for (const num of arr) {
      if (num === 1) {
        counts["a"] = counts["a"] ? counts["a"] + 1 : 1;
      } else if (num === 2) {
        counts["b"] = counts["b"] ? counts["b"] + 1 : 1;
      } else if (num === 3) {
        counts["c"] = counts["c"] ? counts["c"] + 1 : 1;
      } else if (num === 4) {
        counts["d"] = counts["d"] ? counts["d"] + 1 : 1;
      } else if (num === 5) {
        counts["e"] = counts["e"] ? counts["e"] + 1 : 1;
      }
    }
    setNumberOfOccurrence(counts);
  }

  const checkIfArrayValuesAreEqual = (arr) => {
    setIsArrayValuesEqual(arr.every( v => v === arr[0] ));
    return;
  }

  const handleResult = (answers, page) => {
    let savedPage = page;
    if (answers[savedPage-1] === 0) return setIsRequired(true);
    setIsRequired(false);
    countOccurrence(answers);
    checkIfArrayValuesAreEqual(answers);
    handleNextPage(page);
    return;
  }

  const firstSet = questionSet[0].choices.map(obj => 
    <div className="flex" style={{ alignItems: 'baseline' }} key={obj._id}>
      <div className="w-4 h-4 relative">
        <input id={obj._id} type="radio" value="" name="choices" 
          onClick={() => handleSelect(answers, 0, obj._id)}
          checked={(answers[0] === obj._id)}
          readOnly
          className="w-3_h-3 text-[#FFE247] focus:ring-[#FFE247] focus:ring-2 absolute left-1/2 top-[75%] -translate-x-[50%] -translate-y-[50%]" />
      </div>
      <label htmlFor={obj._id} className="ml-2 sm:text-sm text-[12px] w-[80%] font-medium text-[#FFE247] avenir-roman">{obj.answer}</label>
    </div>
  )

  const secondSet = questionSet[1].choices.map(obj => 
    <div className="flex" style={{ alignItems: 'baseline' }} key={obj._id}>
      <div className="w-4 h-4 relative">
        <input id={obj._id} type="radio" value="" name="choices" 
          onClick={() => handleSelect(answers, 1, obj._id)}
          checked={(answers[1] === obj._id)}
          readOnly
          className="w-3_h-3 text-[#FFE247] focus:ring-[#FFE247] focus:ring-2 absolute left-1/2 top-[75%] -translate-x-[50%] -translate-y-[50%]" />
        </div>
      <label htmlFor={obj._id} className="ml-2 sm:text-sm text-[12px] w-[80%] font-medium text-[#FFE247] avenir-roman">{obj.answer}</label>
    </div>
  )

  const thirdSet = questionSet[2].choices.map(obj => 
    <div className="flex" style={{ alignItems: 'baseline' }} key={obj._id}>
      <div className="w-4 h-4 relative">
        <input id={obj._id} type="radio" value="" name="choices" 
          onClick={() => handleSelect(answers, 2, obj._id)}
          checked={(answers[2] === obj._id)}
          readOnly
          className="w-3_h-3 text-[#FFE247] focus:ring-[#FFE247] focus:ring-2 absolute left-1/2 top-[75%] -translate-x-[50%] -translate-y-[50%]" />
        </div>
      <label htmlFor={obj._id} className="ml-2 sm:text-sm text-[12px] w-[80%] font-medium text-[#FFE247] avenir-roman">{obj.answer}</label>
    </div>
  )

  const fourthSet = questionSet[3].choices.map(obj => 
    <div className="flex" style={{ alignItems: 'baseline' }} key={obj._id}>
      <div className="w-4 h-4 relative">
        <input id={obj._id} type="radio" value="" name="choices" 
          onClick={() => handleSelect(answers, 3, obj._id)}
          checked={(answers[3] === obj._id)}
          readOnly
          className="w-3_h-3 text-[#FFE247] focus:ring-[#FFE247] focus:ring-2 absolute left-1/2 top-[75%] -translate-x-[50%] -translate-y-[50%]" />
      </div>
      <label htmlFor={obj._id} className="ml-2 sm:text-sm text-[12px] w-[80%] font-medium text-[#FFE247] avenir-roman">{obj.answer}</label>
    </div>
  )

  const fifthSet = questionSet[4].choices.map(obj => 
    <div className="flex" style={{ alignItems: 'baseline' }} key={obj._id}>
      <div className="w-4 h-4 relative">
        <input id={obj._id} type="radio" value="" name="choices" 
          onClick={() => handleSelect(answers, 4, obj._id)}
          checked={(answers[4] === obj._id)}
          readOnly
          className="w-3_h-3 text-[#FFE247] focus:ring-[#FFE247] focus:ring-2 absolute left-1/2 top-[75%] -translate-x-[50%] -translate-y-[50%]" />
      </div>
      <label htmlFor={obj._id} className="ml-2 sm:text-sm text-[12px] w-[80%] font-medium text-[#FFE247] avenir-roman">{obj.answer}</label>
    </div>
  )

  return (
    <>
      <Modal 
        isOpen={show}
        style={customStyles}
        className="flex justify-center w-full h-full border-none outline-none"
      >
        <div className={`${style.__content} lg:w-[768px] md:w-[500px] sm:w-[450px] w-[90%] md:rounded-[0.8em] top-1/2 translate-y-[-50%] transition duration-500 bg-[#242F6F]`}>
          <div className="absolute right-3 top-3" style={{ zIndex: 9999 }}>
            <button className="text-3xl text-[#C2082A] z-20" onClick={() => handleClose()}>
              <AiFillCloseCircle className="lg:text-5xl absolute -top-6 -right-6"/>
            </button>
          </div>
            {
              page === 0 &&
                <div className="p-5">
                  <BrandLogo className="lg:w-32 lg:h-32 md:w-24 md:h-24 mx-auto mb-5" />
                  <div className="md:text-xl text-lg text-center text-[#F5BC1B] avenir-book font-bold leading-4">Find Your Inner Dragon</div>
                  <div className="md:text-xl text-lg text-center text-[#F5BC1B] avenir-book">Uncover your purpose in a few seconds!</div>
                  <div className="text-center">
                    <button onClick={handleQuiz} className={`${button.__darkOrangeBtn} m-5 avenir-roman`}>
                        <span className='text-md avenir-roman font-normal'> Start now </span>
                    </button>
                  </div>
                </div>
            }

            {/* FIRST QUESTION */}
            {
              page === 1 &&
                <div style={{ zIndex: 1 }}>
                  <div className="lg:px-10 md:px-8 md:py-5 px-5 py-3 mx-auto lg:w-[768px] md:w-[500px] sm:w-[450px] h-auto">
                    <div className="lg:text-lg md:text-md text-sm text-left text-[#FF8A26] avenir-roman leading-4">Question #{questionSet[0]._id}</div>
                    <div className="lg:text-lg md:text-md text-sm text-left text-[#FF8A26] avenir-roman font-bold mb-5">{questionSet[0].question}</div>
                    <div className="grid grid-cols-[50%_50%] min-h-[60px] lg:grid-rows-[40px_40px_40px] grid-rows-[auto_auto_auto] grid-flow-col gap-x-2 lg:gap-y-0 gap-y-2 py-2">
                      {firstSet}
                    </div>
                    <div className="text-center">
                      {
                        isRequired === true &&
                          <div className="lg:text-sm md:text-xs text-xxs text-[#D30112] avenir-roman font-bold">Please choose one value.</div>
                      }
                      <button onClick={() => handleNextPage(page)} className={`${button.__darkOrangeBtn} lg:m-5 m-2 avenir-roman`}>
                          <span className='lg:text-lg md:text-md text-sm avenir-roman font-normal'> Next </span>
                      </button>
                    </div>
                  </div>
                </div>
            }

            {/* SECOND QUESTION */}
            {
              page === 2 &&
                <div style={{ zIndex: 1 }}>
                  <div className="lg:px-10 md:px-8 md:py-5 px-5 py-3 mx-auto lg:w-[768px] md:w-[500px] sm:w-[450px] h-auto">
                    <img
                      src="img/question-modal/Back-Icon.png"
                      alt=""
                      width="25"
                      height="20"
                      onClick={handlePrevPage}
                      style={{ marginBottom: '1.3rem' }}
                    ></img>
                    <div className="lg:text-lg md:text-md text-sm text-left text-[#FF8A26] avenir-roman leading-4">Question #{questionSet[1]._id}</div>
                    <div className="lg:text-lg md:text-md text-sm text-left text-[#FF8A26] avenir-roman font-bold mb-5">{questionSet[1].question}</div>
                    <div className="grid grid-cols-[50%_50%] min-h-[60px] lg:grid-rows-[40px_40px_40px] grid-rows-[auto_auto_auto] grid-flow-col gap-y-2 gap-x-2 py-2">
                      {secondSet}
                    </div>
                    <div className="text-center">
                      {
                        isRequired === true &&
                          <div className="lg:text-sm md:text-xs text-xxs text-[#D30112] avenir-roman font-bold">Please choose one value.</div>
                      }
                      <button onClick={() => handleNextPage(page)} className={`${button.__darkOrangeBtn} lg:m-5 m-2 avenir-roman`}>
                          <span className='lg:text-lg md:text-md text-sm avenir-roman font-normal'> Next </span>
                      </button>
                    </div>
                  </div>
                </div>
            }

            {/* THIRD QUESTION */}
            {
              page === 3 &&
                <div style={{ zIndex: 1 }}>
                  <div className="lg:px-10 md:px-8 md:py-5 px-5 py-3 mx-auto lg:w-[768px] md:w-[500px] sm:w-[450px] h-auto">
                    <img
                      src="img/question-modal/Back-Icon.png"
                      alt=""
                      width="25"
                      height="20"
                      onClick={handlePrevPage}
                      style={{ marginBottom: '1.3rem' }}
                    ></img>
                    <div className="lg:text-lg md:text-md text-sm text-left text-[#FF8A26] avenir-roman leading-4">Question #{questionSet[2]._id}</div>
                    <div className="lg:text-lg md:text-md text-sm text-left text-[#FF8A26] avenir-roman font-bold mb-5">{questionSet[2].question}</div>
                    <div className="flex flex-row gap-x-3 py-2 lg:min-h-[60px]">
                      <div className="flex flex-col">
                        <div className="flex lg:h-[40px] h-auto mb-2" style={{ alignItems: 'baseline' }} key={questionSet[2].choices[0]._id}>
                          <div className="w-4 h-4 relative">
                            <input id={questionSet[2].choices[0]._id} type="radio" value="" name="choices" 
                              onClick={() => handleSelect(answers, 2, questionSet[2].choices[0]._id)}
                              checked={(answers[2] === questionSet[2].choices[0]._id)}
                              readOnly
                              className="w-3_h-3 text-[#FFE247] focus:ring-[#FFE247] focus:ring-2 absolute left-1/2 top-[75%] -translate-x-[50%] -translate-y-[50%]" />
                          </div>
                          <label htmlFor={questionSet[2].choices[0]._id} className="ml-2 sm:text-sm text-[12px] w-[80%] font-medium text-[#FFE247] avenir-roman">{questionSet[2].choices[0].answer}</label>
                        </div>
                        <div className="flex lg:h-[40px] h-auto mb-2" style={{ alignItems: 'baseline' }} key={questionSet[2].choices[1]._id}>
                          <div className="w-4 h-4 relative">
                            <input id={questionSet[2].choices[1]._id} type="radio" value="" name="choices" 
                              onClick={() => handleSelect(answers, 2, questionSet[2].choices[1]._id)}
                              checked={(answers[2] === questionSet[2].choices[1]._id)}
                              readOnly
                              className="w-3_h-3 text-[#FFE247] focus:ring-[#FFE247] focus:ring-2 absolute left-1/2 top-[75%] -translate-x-[50%] -translate-y-[50%]" />
                          </div>
                          <label htmlFor={questionSet[2].choices[1]._id} className="ml-2 sm:text-sm text-[12px] w-[80%] font-medium text-[#FFE247] avenir-roman">{questionSet[2].choices[1].answer}</label>
                        </div>
                        <div className="flex lg:h-[80px] h-auto mb-2" style={{ alignItems: 'baseline', }} key={questionSet[2].choices[2]._id}>
                          <div className="w-4 h-4 relative">
                            <input id={questionSet[2].choices[2]._id} type="radio" value="" name="choices" 
                              onClick={() => handleSelect(answers, 2, questionSet[2].choices[2]._id)}
                              checked={(answers[2] === questionSet[2].choices[2]._id)}
                              readOnly
                              className="w-3_h-3 text-[#FFE247] focus:ring-[#FFE247] focus:ring-2 absolute left-1/2 top-[75%] -translate-x-[50%] -translate-y-[50%]" />
                          </div>
                          <label htmlFor={questionSet[2].choices[2]._id} className="ml-2 sm:text-sm text-[12px] w-[80%] font-medium text-[#FFE247] avenir-roman">{questionSet[2].choices[2].answer}</label>
                        </div>
                      </div>
                      <div className="flex flex-col">
                        <div className="flex lg:h-[80px] h-auto mb-2" style={{ alignItems: 'baseline' }} key={questionSet[2].choices[3]._id}>
                          <div className="w-4 h-4 relative">
                            <input id={questionSet[2].choices[3]._id} type="radio" value="" name="choices" 
                              onClick={() => handleSelect(answers, 2, questionSet[2].choices[3]._id)}
                              checked={(answers[2] === questionSet[2].choices[3]._id)}
                              readOnly
                              className="w-3_h-3 text-[#FFE247] focus:ring-[#FFE247] focus:ring-2 absolute left-1/2 top-[75%] -translate-x-[50%] -translate-y-[50%]" />
                            </div>
                          <label htmlFor={questionSet[2].choices[3]._id} className="ml-2 sm:text-sm text-[12px] w-[80%] font-medium text-[#FFE247] avenir-roman">{questionSet[2].choices[3].answer}</label>
                        </div>
                        <div className="flex lg:h-[40px] h-auto mb-2" style={{ alignItems: 'baseline', height: '40px' }} key={questionSet[2].choices[4]._id}>
                          <div className="w-4 h-4 relative">
                            <input id={questionSet[2].choices[4]._id} type="radio" value="" name="choices" 
                              onClick={() => handleSelect(answers, 2, questionSet[2].choices[4]._id)}
                              checked={(answers[2] === questionSet[2].choices[4]._id)}
                              readOnly
                              className="w-3_h-3 text-[#FFE247] focus:ring-[#FFE247] focus:ring-2 absolute left-1/2 top-[75%] -translate-x-[50%] -translate-y-[50%]" />
                          </div>
                          <label htmlFor={questionSet[2].choices[4]._id} className="ml-2 sm:text-sm text-[12px] w-[80%] font-medium text-[#FFE247] avenir-roman">{questionSet[2].choices[4].answer}</label>
                        </div>
                      </div>
                    </div>
                    <div className="text-center">
                      {
                        isRequired === true &&
                          <div className="lg:text-sm md:text-xs text-xxs text-[#D30112] avenir-roman font-bold">Please choose one value.</div>
                      }
                      <button onClick={() => handleNextPage(page)} className={`${button.__darkOrangeBtn} lg:m-5 m-2 avenir-roman`}>
                          <span className='lg:text-lg md:text-md text-sm avenir-roman font-normal'> Next </span>
                      </button>
                    </div>
                  </div>
                </div>
            }

            {/* FOURTH QUESTION */}
            {
              page === 4 &&
                <div style={{ zIndex: 1 }}>
                  <div className="lg:px-10 md:px-8 md:py-5 px-5 py-3 mx-auto lg:w-[768px] md:w-[500px] sm:w-[450px] h-auto">
                    <img
                      src="img/question-modal/Back-Icon.png"
                      alt=""
                      width="25"
                      height="20"
                      onClick={handlePrevPage}
                      style={{ marginBottom: '1.3rem' }}
                    ></img>
                    <div className="lg:text-lg md:text-md text-sm text-left text-[#FF8A26] avenir-roman leading-4">Question #{questionSet[3]._id}</div>
                    <div className="lg:text-lg md:text-md text-sm text-left text-[#FF8A26] avenir-roman font-bold mb-5">{questionSet[3].question}</div>
                    <div className="grid grid-cols-[50%_50%] min-h-[60px] grid-rows-[40px_40px_40px] grid-flow-col lg:gap-y-0 gap-y-2 gap-x-2 py-2">
                      {fourthSet}
                    </div>
                    <div className="text-center">
                      {
                        isRequired === true &&
                          <div className="lg:text-sm md:text-xs text-xxs text-[#D30112] avenir-roman font-bold">Please choose one value.</div>
                      }
                      <button onClick={() => handleNextPage(page)} className={`${button.__darkOrangeBtn} lg:m-5 m-2 avenir-roman`}>
                          <span className='lg:text-lg md:text-md text-sm avenir-roman font-normal'> Next </span>
                      </button>
                    </div>
                  </div>
                </div>
            }

            {/* FIFTH QUESTION */}
            {
              page === 5 &&
                <div style={{ zIndex: 1 }} className="w-full">
                  <div className="lg:px-10 md:px-8 md:py-5 px-5 py-3 mx-auto lg:w-[768px] md:w-[500px] sm:w-[450px] h-auto">
                    <img
                      src="img/question-modal/Back-Icon.png"
                      alt=""
                      width="25"
                      height="20"
                      onClick={handlePrevPage}
                      style={{ marginBottom: '1.3rem' }}
                    ></img>
                    <div className="lg:text-lg md:text-md text-sm text-left text-[#FF8A26] avenir-roman leading-4">Question #{questionSet[4]._id}</div>
                    <div className="lg:text-lg md:text-md text-sm text-left text-[#FF8A26] avenir-roman font-bold mb-5">{questionSet[4].question}</div>
                    <div className="grid grid-cols-[50%_50%] min-h-[60px] grid-rows-[40px_40px_40px] grid-flow-col lg:gap-y-0 gap-y-2 gap-x-2 py-2">
                      {fifthSet}
                    </div>
                    <div className="text-center">
                      {
                        isRequired === true &&
                          <div className="lg:text-sm md:text-xs text-xxs text-[#D30112] avenir-roman font-bold">Please choose one value.</div>
                      }
                      <button onClick={() => handleResult(answers, page)} className={`${button.__darkOrangeBtn} lg:m-5 m-2 avenir-roman`}>
                          <span className='lg:text-lg md:text-md text-sm avenir-roman font-normal'> Next </span>
                      </button>
                    </div>
                  </div>
                </div>
            }

            {/* RESULT SECTION */}

            {/* FIRST CONDITION: ALL ANSWERS ARE LETTER EITHER 'A|B|C|D|E'
            // SECOND CONDITION: ALL ANSWERS CONTAIN MORE THAN 2 LETTERS OF 'A|B|C|D|E' */}

            {(() => {
              if (page === 6 && ((isArrayValuesEqual === true && answers.includes(1)) || (numberOfOccurrence["a"] >= 2))) {
                result = 
                    <div className="lg:p-10 md:p-8 sm:p-5 p-5" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                      <div className="lg:text-5xl md:text-4xl text-4xl text-left text-[#FFD600] font-mm font-bold uppercase">Game Changer</div>
                      <div className="lg:text-xl md:text-lg text-base text-left text-center text-[#FFE247] avenir-roman">You champion for those who want to immerse into the unusual yet beneficial.</div>
                      <div className="text-center mt-5">
                        <button onClick={() => handleReadMore("game-changer")} className={`${button.__darkOrangeBtn} lg:m-5 m-2 avenir-roman`}>
                            <span className='lg:text-lg md:text-md text-sm avenir-roman font-normal'> Read more </span>
                        </button>
                      </div>
                    </div>
                return result;
              } else if (page === 6 && ((isArrayValuesEqual === true && answers.includes(2)) || (numberOfOccurrence["b"] >= 2))) {
                result = 
                    <div className="lg:p-10 md:p-8 p-5" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                      <div className="lg:text-5xl md:text-4xl text-4xl text-left text-[#FFD600] font-mm font-bold uppercase">Creator</div>
                      <div className="lg:text-xl md:text-lg text-base text-left text-center text-[#FFE247] avenir-roman">You champion for those looking to leave an indelible mark in this world.</div>
                      <div className="text-center mt-5">
                        <button onClick={() => handleReadMore("creator")} className={`${button.__darkOrangeBtn} lg:m-5 m-2 avenir-roman`}>
                            <span className='lg:text-lg md:text-md text-sm avenir-roman font-normal'> Read more </span>
                        </button>
                      </div>
                    </div>
                return result;
              } else if (page === 6 && ((isArrayValuesEqual === true && answers.includes(3)) || (numberOfOccurrence["c"] >= 2))) {
                result = 
                    <div className="" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                      <div className="lg:text-5xl md:text-4xl text-4xl text-left text-[#FFD600] font-mm font-bold uppercase">Explorer</div>
                      <div className="lg:text-xl md:text-lg text-base text-left text-center text-[#FFE247] avenir-roman">You champion for those who ambitiously look for experiences.</div>
                      <div className="text-center mt-5">
                        <button onClick={() => handleReadMore("explorer")} className={`${button.__darkOrangeBtn} lg:m-5 m-2 avenir-roman`}>
                            <span className='lg:text-lg md:text-md text-sm avenir-roman font-normal'> Read more </span>
                        </button>
                      </div>
                    </div>
                return result;
              } else if (page === 6 && ((isArrayValuesEqual === true && answers.includes(4)) || (numberOfOccurrence["d"] >= 2))) {
                result =
                    <div className="lg:p-10 md:p-8 p-5" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                      <div className="lg:text-5xl md:text-4xl text-4xl text-left text-[#FFD600] font-mm font-bold uppercase">Caregiver</div>
                      <div className="lg:text-xl md:text-lg text-base text-left text-center text-[#FFE247] avenir-roman">You champion for those who commit their lives in giving love to others.</div>
                      <div className="text-center mt-5">
                        <button onClick={() => handleReadMore("caregiver")} className={`${button.__darkOrangeBtn} lg:m-5 m-2 avenir-roman`}>
                            <span className='lg:text-lg md:text-md text-sm avenir-roman font-normal'> Read more </span>
                        </button>
                      </div>
                    </div>
                return result;
              } else if (page === 6 && ((isArrayValuesEqual === true && answers.includes(5)) || (numberOfOccurrence["e"] >= 2))) {
                result = 
                    <div className="lg:p-10 md:p-8 p-5" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                      <div className="lg:text-5xl md:text-4xl text-4xl text-left text-[#FFD600] font-mm font-bold uppercase">Sage</div>
                      <div className="lg:text-xl md:text-lg text-base text-left text-center text-[#FFE247] avenir-roman">You champion for those finding themselves through spiritual discovery.</div>
                      <div className="text-center mt-5">
                        <button onClick={() => handleReadMore("sage")} className={`${button.__darkOrangeBtn} lg:m-5 m-2 avenir-roman`}>
                            <span className='lg:text-lg md:text-md text-sm avenir-roman font-normal'> Read more </span>
                        </button>
                      </div>
                    </div>
                return result;
              }
            })()}
        </div>
      </Modal>
    </>
  );
}
